import script from "./flash.vue?vue&type=script&setup=true&lang=js"
export * from "./flash.vue?vue&type=script&setup=true&lang=js"

import "./flash.vue?vue&type=style&index=0&id=74249c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74249c8a"]])

export default __exports__